import { HTTP_TOKEN } from "./http";

export const getCampaign = (campaign_id) => {
  return HTTP_TOKEN.get(`campaign/${campaign_id}`).then((result) => {
    return result.data;
  });
};


export const getCampaigns = (params) => {
  return HTTP_TOKEN.get("campaign", { params }).then((result) => {
    return result.data;
  });
};

export const createCampaign = (data) => {
  return HTTP_TOKEN.post("campaign", data).then((result) => {
    return result.data;
  });
};

export const updateCampaign = (campaign_id, data) => {
  return HTTP_TOKEN.put(`campaign/${campaign_id}`, data).then((result) => {
    return result.data;
  });
};

export const removeCampaign = (campaign_id) => {
  return HTTP_TOKEN.delete(`campaign/${campaign_id}`).then((result) => {
    return result.data;
  });
};

export const getCampaignContactReport = (campaign_id) => {
  return HTTP_TOKEN.get(`campaign/${campaign_id}/report`).then((result) => {
    return result.data;
  });
};

export const duplicateCampaign = (campaign_id) => {
  return HTTP_TOKEN.post(`campaign/${campaign_id}/duplicate`).then((result) => {
    return result.data;
  });
};
